import { render, staticRenderFns } from "./feiInfo.vue?vue&type=template&id=40d24223&scoped=true"
import script from "./feiInfo.vue?vue&type=script&lang=js"
export * from "./feiInfo.vue?vue&type=script&lang=js"
import style0 from "./feiInfo.vue?vue&type=style&index=0&id=40d24223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d24223",
  null
  
)

export default component.exports